module.exports = __webpack_public_path__ + "static/media/info.1f9ac7b6.png";